export const NOTIFICATION_SUCCESS = '@@notification/SUCCESS';
export const NOTIFICATION_ERROR = '@@notification/ERROR';
export const NOTIFICATION_WARNING = '@@notification/WARNING';
export const NOTIFICATION_INFO = '@@notification/INFO';

interface NotificationAction {
  type:
    | typeof NOTIFICATION_SUCCESS
    | typeof NOTIFICATION_ERROR
    | typeof NOTIFICATION_WARNING
    | typeof NOTIFICATION_SUCCESS
    | typeof NOTIFICATION_INFO;
  payload?: string;
}

export interface NotificationState {
  successMsg?: string;
  errorMsg?: string;
  warningMsg?: string;
  infoMsg?: string;
}

export type NotificationActionTypes = NotificationAction;
